import { render, staticRenderFns } from "./sale-item-new.vue?vue&type=template&id=de23170c"
import script from "./sale-item-new.vue?vue&type=script&lang=js"
export * from "./sale-item-new.vue?vue&type=script&lang=js"
import style0 from "./sale-item-new.vue?vue&type=style&index=0&id=de23170c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports